import { SearchSuggestItem } from "@services/krent.service";
import "../../../search.css";

type SearchSuggestDropdownProps = {
  items: SearchSuggestItem[];
  open: boolean;
  activeIndex: number;
  onHover: (index: number) => void;
  onSelect: (item: SearchSuggestItem) => void;
};

const TYPE_LABEL: Record<SearchSuggestItem["type"], string> = {
  location: "Location",
  listing: "Stay",
  reference: "Ref",
};

const TYPE_ICON: Record<SearchSuggestItem["type"], string> = {
  location: "fa-map-marker-alt",
  listing: "fa-home",
  reference: "fa-hashtag",
};

export const SearchSuggestDropdown = ({
  items,
  open,
  activeIndex,
  onHover,
  onSelect,
}: SearchSuggestDropdownProps) => {
  if (!open || items.length === 0) return null;

  return (
    <ul className="search-suggest-menu" role="listbox">
      {items.map((item, index) => (
        <li key={`${item.type}-${item.query}`} role="presentation">
          <button
            type="button"
            role="option"
            aria-selected={index === activeIndex}
            className={`search-suggest-item${
              index === activeIndex ? " active" : ""
            }`}
            onMouseEnter={() => onHover(index)}
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => onSelect(item)}
          >
            <i className={`fas ${TYPE_ICON[item.type]}`} aria-hidden="true" />
            <span className="search-suggest-copy">
              <span className="search-suggest-label">{item.label}</span>
              {item.subtitle ? (
                <span className="search-suggest-sub">{item.subtitle}</span>
              ) : null}
            </span>
            <span className="search-suggest-type">{TYPE_LABEL[item.type]}</span>
          </button>
        </li>
      ))}
    </ul>
  );
};
